module.exports = __webpack_public_path__ + "img/card-configuration-services-and-cost-hover.dee8df79.svg";